/**
 * Converte o nome interno de uma PropriedadeEquipamento em label legível.
 * Ex: "NUMERO_CHASSI" → "Número Chassi"
 */
export function formatNomeCampo(nome: string): string {
  if (!nome) return '';
  return nome
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, c => c.toUpperCase());
}
